export const UPLOAD_FILE_NAME_PREFIX = "__gcrud_upload";
export const CSS_VARIABLE_PREFIX = "--gc-";
